import { formatLong, shiftDays, todayIso } from '../dates'

export type SaveState = 'idle' | 'saving' | 'saved' | 'error'

interface Props {
  date: string
  onChange: (date: string) => void
  answered: number
  total: number
  save: SaveState
}

export default function DateNav({ date, onChange, answered, total, save }: Props) {
  const today = todayIso()
  const isToday = date === today

  return (
    <header className="topbar">
      <button
        className="step"
        type="button"
        aria-label="Previous day"
        onClick={() => onChange(shiftDays(date, -1))}
      >
        ‹
      </button>

      <label className="date">
        {isToday ? 'Today' : formatLong(date)}
        <small>{isToday ? formatLong(date) : ''}</small>
        <input
          type="date"
          value={date}
          max={today}
          onChange={(e) => e.target.value && onChange(e.target.value)}
          style={{
            position: 'absolute',
            inset: 0,
            opacity: 0,
            width: '100%',
            height: '100%',
            cursor: 'pointer',
          }}
        />
      </label>

      <span
        className={`progress${answered === total ? ' complete' : ''}`}
        role="status"
        aria-live="polite"
      >
        <span className="save-dot" data-state={save} aria-hidden="true" />
        {answered}/{total}
        <span className="sr-only">
          {save === 'saving' ? ' saving' : save === 'saved' ? ' saved' : save === 'error' ? ' not saved' : ''}
        </span>
      </span>

      <button
        className="step"
        type="button"
        aria-label="Next day"
        disabled={isToday}
        onClick={() => onChange(shiftDays(date, 1))}
      >
        ›
      </button>
    </header>
  )
}
